import RequiredSign from "@components/common/ui-elements/required-sign";
import React from "react";
import uuid4 from "@utils/uuid4";
import {isPlainObject} from "@utils/object";
import {generateIdFromName} from "../../../../utils/string";
import {isDetailsMode, isEditableMode, useFormMode} from "@contexts/FormModeContext";

export default function ScrollableCheckBoxListBlock(
   {
      containerCssClass = 'col-12 py-3',
      dataBlock = 'block-id',
      required = false,
      options = [],
      selectedValues = [],
      onChange,
      helpText = '',
      controlId = '',
      controlName = '',
      controlAttrs = {},
      labelText = 'Control Label',
      inlineCheckBoxes = false,
   }
) {
   
   const {mode} = useFormMode();
   
   
   let selectedValuesFormatted = '';
   
   if (isDetailsMode(mode)) {
      
      if (Array.isArray(selectedValues)) {
         selectedValuesFormatted = selectedValues.join(', ');
      } else if (isPlainObject(selectedValues)) {
         selectedValuesFormatted = '-';
      } else {
         selectedValuesFormatted = selectedValues;
      }
      
   }
   
   let paramError = '';
   
   
   // region [Additional Css Class]
   
   if (typeof containerCssClass === 'string') {
      containerCssClass += ' scrollable';
   } else if (Array.isArray(containerCssClass)) {
      
      containerCssClass = (containerCssClass.join(' ')) + ' scrollable';
      
   } else {
      containerCssClass = 'scrollable';
   }
   
   if(isDetailsMode(mode)) {
      containerCssClass += ' details-mode';
   }
   
   // endregion
   
   // region [Control Name]
   
   if (typeof controlName !== 'string') {
      
      paramError = ("Control name for check boxes must be a string data type");
      
   } else if (controlName.trim() === '') {
      paramError = ("Control name for check boxes cannot be empty");
   }
   
   controlAttrs.name = controlName;
   
   // endregion
   
   // region [Control Attrs]
   
   if (!isPlainObject(controlAttrs)) {
      controlAttrs = {};
   }
   
   delete controlAttrs.name;
   
   // endregion
   
   // region [Label Text]
   
   if (typeof labelText !== 'string') {
      labelText = '';
   } else {
      labelText = labelText.trim();
   }
   
   // endregion
   
   // region [Control ID]
   
   if (typeof controlId !== 'string' || controlId.trim() === '') {
      controlId = generateIdFromName(controlName);
   }
   
   // endregion
   
   
   return (
      <div className={containerCssClass} data-block={dataBlock}>
         
         {labelText !== '' && (
            <label
               htmlFor={controlId}
               className="form-label">
               {labelText} <RequiredSign required={required} />
            
            </label>
         )}
         
         {isEditableMode(mode) && (
            <>
               <div>
                  
                  {paramError !== '' && (
                     <p className="text-danger">{paramError}</p>
                  )}
                  
                  {paramError === '' && (
                     options?.map((opt, index) => (
                        <div
                           key={index}
                           className={`form-check ${inlineCheckBoxes ? 'form-check-inline' : ''}`}
                        >
                           <input
                              className="form-check-input"
                              type="checkbox"
                              id={controlId + '-' + index}
                              value={opt.value}
                              checked={selectedValues.includes(opt.value)}
                              onChange={onChange}
                              name={controlName}
                              {...controlAttrs}
                           />
                           <label
                              className="form-check-label"
                              htmlFor={controlId + '-' + index}
                           >
                              {opt.label}
                           </label>
                        </div>
                     ))
                  )}
               
               
               </div>
               
               {helpText !== '' && (
                  <div className="form-text mt-2">
                     {helpText}
                  </div>
               )}
            </>
         )}
         
         {isDetailsMode(mode) && (
            <>
               <div className="form-text">
                  {selectedValuesFormatted}
               </div>
            </>
         )}
         
         
         {isEditableMode(mode) && process.env.NEXT_PUBLIC_DISPLAY_CONTROL_NAMES === "1" && (
            <div className="mt-3 d-flex flex-column gap-3" style={{width: 'fit-content'}}>
               
               <p className="m-0 p-3 text-danger badge bg-primary-subtle fs-6 text-break">
                  {controlName}
               </p>
               
               <p className="m-0 p-3 text-black badge bg-success-subtle fs-6 text-break">
                  {dataBlock}
               </p>
            
            </div>
         )}
      
      </div>
   );
   
}